import React from "react"
import cancelRequesticon from '../assets/CancelRedeemRequesticon.svg'
import { connect } from "react-redux";
import { toggleModalAction, getCancleWithdrawAction } from '../redux/actions/userAction'
import { REDEEM_HISTORY, RUPEE_SYMBOL } from "../Strings"
import Loading from "../models/Loading";
import { WebToNativeMessage } from "../Common/Utils";
import RedeemCancelSuccess from '../assets/Redeem-revamp/RedeemCancelSuccess.svg'
import CancelRedeemSuccess from '../assets/Redeem-revamp/CancelRedeemSuccess.svg'
import oemCancelRedeemSuccess from '../OemAssets/SuccessIcon.svg'
import CancelRedeemFailure from '../assets/Redeem-revamp/CancelRedeemFailure.svg'
import remove2 from '../assets/Redeem-revamp/remove2.svg'
import Cross2 from '../assets/Redeem-revamp/Cross2.svg'
import Cross from '../assets/Redeem-revamp/Cross.svg'
import oemCross from '../OemAssets/close.svg';
import rupeeIconNew from '../assets/Redeem-revamp/rupeecoinnew.svg'
import oemRupeeIconNew from '../OemAssets/RupeeIcon.svg'
import infoIconBlue from '../assets/infoIconBlue.svg'
import { isTablet } from "react-device-detect";
const cssPath = sessionStorage.getItem("channel") === 'OEMAPS1'
  ? './RedeemCancelOEM.css'
  : './RedeemCancel.css';
import(`${cssPath}`)

// const [isOem,setIsOem]=userState(false);

// const isOem = false;
class RedeemCancel extends React.Component {

  constructor(props) {
    super(props)
    if(sessionStorage.getItem("channel") === "OEMAPS1"){
      import('./RedeemCancelOEM.css');
  }
    this.state = {
      errors: {
        message: ""
      },
      token: window.sessionStorage["token"],
      channel: window.sessionStorage["channel"],
      isLoading: false,
      CancelRequestFailed: false,
      CancelRequestSuccess: false,
      isOem : false
    };

  }
  async componentWillMount() {
    // console.log("It came to here >>>>>>>>>>>>>>>>>>>>>>>>>>");
    window.sessionStorage["pageTypeToReload"] = "redeemCancel";
    this.setState({
      isOem:sessionStorage.getItem("channel") === "OEMAPS1"
    })
  }

  // handleCanclerequestFailurePopUp = async () => {
  // }

  handleCancleRequest = async () => {
    console.log("cancle withdraw transaction id::::", this.props.tnx_id)
    this.setState({ isLoading: true })

    //INPUT = {

    // Send accessToken in Headers
    //"tnxId": String
    //"channel": String
    //}
    // OUTPUT_FORMAT = {
    //"statusCode": Int,
    //"message": String
    // }
    console.log("cancel withdraw transaction id::::", this.props.tnx_id, this.props.redeemableamount, this.props.redeemOption)
    await this.props.getCancleWithdrawAction(this.state.token, this.props.tnx_id, this.state.channel,this.props.location);
    const { cancleWithdrawRes } = this.props.userState;

    if (cancleWithdrawRes.error) {
      console.log("cancle request details error::::", cancleWithdrawRes.error);
      // await this.setState({
      //   errors: { message: cancleWithdrawRes.message }

      // })
      this.setState({ CancelRequestFailed: true })
      if (cancleWithdrawRes.error.message) {
        sessionStorage.setItem('statusCode', JSON.stringify(cancleWithdrawRes.statusCode));
        sessionStorage.setItem('cancelresponse', JSON.stringify(cancleWithdrawRes.error.message));
        this.props.updateRequestResponse(cancleWithdrawRes.statusCode, cancleWithdrawRes.error.message)
      } else {
        sessionStorage.setItem('cancelresponse', JSON.stringify(cancleWithdrawRes.error));
        this.props.updateRequestResponse(cancleWithdrawRes.statusCode, "DB Error")
      }

      this.setState({ isLoading: false })
      this.props.toggleModalAction(true, this.createRedeemCancelStatusPopUp(false))

    } else {
      console.log("React cancle withdraw success", cancleWithdrawRes.message);
      this.setState({ CancelRequestSuccess: true })
      // WebToNativeMessage({ type: "redeemCTEvent", eventName: "pf_s_redeemusercancelled" })

      await this.setState({
        //errors: { message: cancleWithdrawRes.message } 
      })
      this.setState({ isLoading: false })
      // WebToNativeMessage({ type: "redeemCTEvent", eventName: "RedeemCancelled", eventProperties: { requestId: this.props.transactionId, redeemAmount: this.props.redeemableamount, redeemOption: this.props.redeemOption, channel: this.state.channel } })
      this.props.toggleModalAction(true, this.createRedeemCancelStatusPopUp(true))
      sessionStorage.setItem('statusCode', JSON.stringify(cancleWithdrawRes.statusCode));
      sessionStorage.setItem('cancelresponse', JSON.stringify(cancleWithdrawRes.message));
      this.props.updateRequestResponse(cancleWithdrawRes.statusCode, cancleWithdrawRes.message)
    }
  }
  

  // createRedeemCancelStatusPopUp = (value) => {
  //   let status;
  //   status = <div style={{ position: 'absolute',...(isTablet ? {width:"50%",left:"25%"} : {width:"80%",left:"10%"}), height: '25%', top: "37.5%", display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'center', background: "#f9f9f9", borderRadius: '5px', boxShadow: '0px 0px 4px 0px #00000040' }}>
  //     <img src={Cross2} alt='close' style={{ position: 'absolute', right: '3%', top: '5%' }} onClick={() => { !value ? this.props.toggleModalAction(false) : this.props.toggleModalAction(false);this.props.handleRefresh() }} />
  //     <div style={{ width: '90%', height: "30%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}><img style={{ width: '100%', height: '80%' }} src={value ? RedeemCancelSuccess : remove2} /></div>
  //     <div style={{ color: '#032146', fontSize: '1rem', fontWeight: "700", marginTop: '1%' }}>{value ? 'Redeem Cancelled' : 'Cancel Request Failed'}</div>
  //     {value ? <div style={{ color: '#196A29', fontSize: '0.9rem', marginTop: '4%', textAlign: 'center' }}><span style={{ fontWeight: '700' }}>{RUPEE_SYMBOL}{this.props.redeemAmount}</span> has been credited to your A23 wallet.</div> : <div style={{ color: '#707070', fontSize: '0.8rem', fontWeight: '500', marginTop: '4%', textAlign: 'center' }}>Your Redeem Request couldn't be cancelled due to some technical issues. </div>}
  //     {<div style={{ width: "40%", height: '15%', display: 'flex', background: "linear-gradient(180deg, #42BE40 0%, #196A29 100%)", alignItems: 'center', marginTop: '4%', justifyContent: 'center', color: '#ffffff', border: '1px solid #42BE40', borderRadius: "4px", fontWeight: '700' }} onClick={() => { this.props.toggleModalAction(false); this.props.handleRefresh(); WebToNativeMessage({type:'closeClient'}) }}>Back to Lobby</div>}
  //   </div>
  //   return status
  // }

  createRedeemCancelStatusPopUp = (value) => {
    let status;
    status = <div className="redeemCancelContainer" style={{ position: 'absolute',...(isTablet ? {width:"50%",left:"25%"} : {width:"80%",left:"10%"}), height: '30%', top: "35%", display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'center', borderRadius: '5px'}}>
      <div className="redeemCancelHeader" style={{display:"flex",alignItems:"center",position:"absolute",top:"0",justifyContent:"center",fontWeight:"700",width:"100%",height:"40px",borderRadius:"4px 4px 0px 0px"}}>
        Withdrawal Cancellation
      <img src={!this.state.isOem?Cross:oemCross} alt='close' style={{ position: 'absolute', right: '3%' }} onClick={() => { !value ? this.props.toggleModalAction(false) : this.props.toggleModalAction(false);this.props.handleRefresh() }} />
      </div>
      <div style={{ width: '90%', height: "30%", display: 'flex', alignItems: 'center', justifyContent: 'center',marginTop:'20px' }}><img style={{ width: '100%', height: '80%',marginTop:"5%" }} src={value ? !this.state.isOem?CancelRedeemSuccess:oemCancelRedeemSuccess : CancelRedeemFailure} /></div>
      <div className="confirmRedeemText" style={{ fontSize: '1rem', fontWeight: "700", marginTop: '1%' }}>{value ? 'Withdraw Cancelled' : 'Cancel Request Failed'}</div>
      {value ? <div className="CancelCreditedText" style={{  fontSize: '0.9rem', marginTop: '4%', textAlign: 'center' }}><span style={{ fontWeight: '700' }}>{RUPEE_SYMBOL}{this.props.redeemableamount}</span> has been credited to your {window.sessionStorage.getItem("channel") !== "OEMAPS1"? <span>A23 wallet.</span> : <span>wallet.</span> } </div> : <div style={{ color: '#707070', fontSize: '0.8rem', fontWeight: '500', marginTop: '4%', textAlign: 'center' }}>Your Withdraw Request couldn't be cancelled due to some technical issues. </div>}
      {<div className="RedeemCancelYesButton" style={{ width: "40%", height: '15%', display: 'flex', alignItems: 'center', marginTop: '4%', justifyContent: 'center', borderRadius: "4px", fontWeight: '700' }} onClick={() => { this.props.toggleModalAction(false); this.props.handleRefresh(); WebToNativeMessage({type:'closeClient'}) }}>Back to Lobby</div>}
    </div>
    return status
  }

  RedeemCancelCT = () => {
    let eventProperties = {

      Button_clicked: "No",
      acelevel: window.sessionStorage["aceLevel"],
      channel: window.sessionStorage["channel"],
      subscription_type: window.sessionStorage["subscriptionType"],
      username: window.sessionStorage["screenName"],
      Redeem_Amount: this.props.redeemAmount,
      redeem_mode: this.props.redeemOption,
      Location: this.props.click_location,
      RedeemType: this.props.transactionType,
      isSmartRedeem: this.props.isSmartRedeem ? 'Yes' : 'No'
    }
    WebToNativeMessage(
      {
        type: "redeemCTEvent", eventName: "PF_c_clickin_CancellationPopUp", eventProperties: eventProperties
      })
    WebToNativeMessage(
      {
        type: "mixpanelEvent", eventName: "PF_c_clickin_CancellationPopUp", eventProperties: eventProperties
      })
  }

  render() {
    console.log(this.props, 'sidd')
    return (
      <>
      {
        this.state.isLoading ? <div className="center">
          <Loading />
        </div> :

          // Old Redeem Cancel Pop Up Start

          // <div>


          //   <div className="relative absolute--fill flex justify-center items-center center left-1 right-1 white  w6 w-100">
          //     <img src={Cross2} alt='close' style={{ position: 'absolute', right: '5%', top: '6%' }} onClick={() => { this.props.toggleModalAction(false) }} />
          //     <img className="absolute black mt2 left-0 top-0 right-0 h3 w3 center white flex justify-center items-center z-9999 " style={{width:"3.5rem",height:"3.5rem",marginTop:"4%"}} src={cancelRequesticon} alt="not available" />
          //     <div className="center br2 ba pa1 b--black-10 flex flex-column" style={{ width: "100%", backgroundColor: "#F9F9F9", color: "#032146", bordercolor: "#EABF6979", paddingTop: "1rem" }}
          //     >
          //       <div className="db pt1 f6 mt5 center w-90">
          //         <div className="w-100 db f6 tc">
          //           <h4 className=" mt0 mb3 fw6  f5 " style={{ color: "#032146" }}>{REDEEM_HISTORY.REDEEM_HISTORY_CANCEL_REDEEM} </h4>
          //           <div className=" f6 text-medium mb3 ">{REDEEM_HISTORY.REDEEM_HISTORY_TEXT}  </div>
          //           <div className=" f6 text-medium mb4 green">
          //             <span style={{ color: "#196A29" }}>
          //               &#8377; {this.props.redeemableamount} will be credited back to your A23 wallet instantly.
          //             </span>  </div>
          //         </div>



          //         {
          //           this.state.isLoading ? (<div className="tc mb2 flex justify-between mt1">
          //             <button className='ph4 pv2 tc center  ba br2 f5 dib fw4'
          //               style={{ height: "auto", width: "45%", borderColor: "#196A29", color: "#196A29", backgroundColor: "#F9F9F9", borderWidth: "1px",fontWeight:"700" }} type='submit'>{REDEEM_HISTORY.REDEEM_HISTORY_NO_BUTTON}</button>

          //             <button className='ph4 pv2 tc center bw0 f5 fw4 dib br2 btn-green btn-green-login white'
          //               style={{ height: "auto", width: "45%",fontWeight:"700" }} type='submit'>{REDEEM_HISTORY.REDEEM_HISTORY_YES_BUTTON}</button>

          //           </div>) :
          //             (<div className="tc mb2 flex justify-between mt1 w-100">




          //               <button className='ph4 pv2 tc center  ba br2 f5 dib fw4'
          //                 style={{ height: "auto", width: "45%", borderColor: "#196A29", color: "#196A29", backgroundColor: "#F9F9F9", borderWidth: "1px",fontWeight:"700" }} onClick={() => { this.props.toggleModalAction(false); this.RedeemCancelCT(); }
          //                 } type='submit'>{REDEEM_HISTORY.REDEEM_HISTORY_NO_BUTTON}</button>

          //               <button className='ph4 pv2 tc center bw0 f5 fw4 dib br2 btn-green btn-green-login white' onClick={e => {
          //                 this.handleCancleRequest(); WebToNativeMessage(
          //                   {
          //                     type: "redeemCTEvent", eventName: "PF_c_clickin_CancellationPopUp", eventProperties: {
          //                       Button_clicked: "Yes",
          //                       acelevel: window.sessionStorage["aceLevel"],
          //                       channel: window.sessionStorage["channel"],
          //                       subscription_type: window.sessionStorage["subscriptionType"],
          //                       username: window.sessionStorage["screenName"],
          //                       Redeem_Amount: this.props.redeemAmount,
          //                       redeem_mode: this.props.redeemOption
          //                     }

          //                   })
          //               }}
          //                 style={{ height: "auto", width: "45%",fontWeight:"700" }} type='submit'>{REDEEM_HISTORY.REDEEM_HISTORY_YES_BUTTON}</button>



          //             </div>)}


          //         <div className="tc ">

          //           &nbsp;

          //         </div>

          //       </div>
          //     </div>
          //   </div>



          // </div>

          // Old Redeem Cancel Pop up end

          <div>
            <div style={{width:'90%',height:'50%',position:"absolute",top:'25%',left:'5%',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <div className="redeemCancelContainer"  style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',width:'100%',borderRadius:'5px'}}>

                  <div className="redeemCancelHeader" style={{ width: '100%', height: '45px',  borderRadius: '4px 4px 0px 0px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '1rem' }}>
                    Withdraw Cancellation
                    <img src={!this.state.isOem?Cross:oemCross} style={{ position: 'absolute', right: '5%' }} onClick={() => { this.props.toggleModalAction(false) }}/>
                  </div>
                  <div style={{ width: '90%', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'end', flexDirection: 'column',marginTop:'5px',marginBottom:'5px' }}>
                    <div className="RedeemCancelAmount" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "1rem", fontWeight: '700' }}> <img src={!this.state.isOem?rupeeIconNew:oemRupeeIconNew} style={{ marginRight: "8%" }} />{RUPEE_SYMBOL}{this.props.redeemableamount}</div>
                   {sessionStorage.getItem("channel").toLowerCase() !== "oemaps1" ? <div className="RedeemCreditedText" style={{ width: '100%', fontSize: '0.8rem', textAlign: 'center', marginTop: '4%' }}>will be credited back to your A23 wallet instantaneously.</div> : <div className="RedeemCreditedText"  style={{ width: '100%', fontSize: '0.8rem', textAlign: 'center', marginTop: '4%' }}>will be credited back to your wallet instantaneously.</div>}
                  </div>
                  {/* {(this.props?.transactionType==='Prime Instant' || this.props?.transactionType==='paidInstant') && <div style={{ minWidth:"80%",maxWidth:"92%", height: '35px', border: '1.5px solid #032146', borderLeft: '5px solid #032146', display: "flex", flexDirection: 'row', boxSizing: 'border-box',marginTop:"5px",marginBottom:'5px',borderRadius:'0px 4px 4px 0px' }}>
                    <div style={{ width: '10%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><img src={infoIconBlue} style={{ width: '50%', height: '50%' }} /></div>
                    <div style={{ width: '88%', height: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', marginLeft: '2%', fontWeight: '600', fontSize: '0.75rem' }}>{this.props?.cancelConfirmationInfoMsg}</div>
                  </div>} */}
                  <div className="confirmRedeemText" style={{width:'92%',textAlign:'center',fontSize:'0.8rem',margin:"5px 0px"}}>Are you sure you want to cancel your withdrawal request?</div>
                  <div style={{ width: '90%', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly',marginTop:'10px',marginBottom:"10px" }}>
                    <div className="RedeemCancelNoButton" style={{  width: '40%', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px',fontWeight:"700" }} onClick={() => { this.props.toggleModalAction(false); this.RedeemCancelCT();}}>{REDEEM_HISTORY.REDEEM_HISTORY_NO_BUTTON}</div>
                    <div className="RedeemCancelYesButton"  style={{ width: '40%', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px',fontWeight:'700' }} onClick={e => {
                          this.handleCancleRequest();
                      let eventProperties = {
                        Button_clicked: "Yes",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscription_type: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        Redeem_Amount: this.props.redeemAmount,
                        redeem_mode: this.props.redeemOption,
                        Location: this.props.click_location,
                        RedeemType: this.props.transactionType,
                        isSmartRedeem: this.props.isSmartRedeem ? 'Yes' : 'No'
                      }
                           WebToNativeMessage(
                            {
                              type: "redeemCTEvent", eventName: "PF_c_clickin_CancellationPopUp", eventProperties: eventProperties
                            })
                            WebToNativeMessage(
                              {
                                type: "mixpanelEvent", eventName: "PF_c_clickin_CancellationPopUp", eventProperties: eventProperties
                              })
                        }}>{REDEEM_HISTORY.REDEEM_HISTORY_YES_BUTTON}</div>

                  </div>
                </div>

              </div>
            </div>


      }
      </>

    )
  }
}
const mapStateToProps = state => ({
  userState: state.userState
});

export default connect(mapStateToProps, { toggleModalAction, getCancleWithdrawAction })(RedeemCancel);
